import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const HourlyIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <g clipPath="url(#hourly_svg__a)">
      <path
        fillRule="evenodd"
        d="M6.017.667a.75.75 0 0 1 .75-.75H9.7a.75.75 0 0 1 0 1.5h-.717v.74a6.984 6.984 0 1 1-1.5 0v-.74h-.716a.75.75 0 0 1-.75-.75M3.756 1.67a.75.75 0 0 1 0 1.061l-1.1 1.1a.75.75 0 0 1-1.06-1.06l.549-.55.55-.55a.75.75 0 0 1 1.06 0m8.955 0a.75.75 0 0 1 1.06 0l1.1 1.1a.75.75 0 1 1-1.06 1.061l-.55-.55-.55-.55a.75.75 0 0 1 0-1.06M8.233 3.617a5.483 5.483 0 1 0 0 10.966 5.483 5.483 0 0 0 0-10.966m0 1.8a.75.75 0 0 1 .75.75v2.508l1.47.882a.75.75 0 1 1-.772 1.286l-1.834-1.1a.75.75 0 0 1-.364-.643V6.167a.75.75 0 0 1 .75-.75"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="hourly_svg__a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
HourlyIcon.id = 'HourlyIcon';
HourlyIcon.displayName = 'HourlyIcon';
export default HourlyIcon;
